import { type CityProfile } from '@core/city-profile/city-profile'

// the Mexico City demo profile — fourth demo city alongside Lyon, Lisbon and Torino.
// centre is the Zócalo (Plaza de la Constitución) ; the UI runs in Spanish (both the frontend
// dictionaries and the gwapi dictionary already carry 'es', so a demomexico build is localised
// out of the box, like the Turin one).
// the zoom levels are looser than the European cities on purpose : the CDMX demo dataset spans
// Indios Verdes → Xochimilco and Santa Fe → Pantitlán, roughly 0.3° of longitude.
export const kMexicoProfile: CityProfile = {
  id: 'mexico',
  displayName: 'Movilidad Ciudad de México',
  brandLines: ['Movilidad', 'Ciudad de México'],
  center: [-99.1332, 19.4326],
  zoom: 11.6,
  supervisionZoom: 11.0,
  locale: 'es-mx',
  tz: 'America/Mexico_City',
  currency: '$',
}
